module.exports = __webpack_public_path__ + "img/login-lalibertad.c384152e.svg";